const Samples = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    color="inherit"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.48 5.19c-.07-1.143-.695-1.761-1.834-1.761-1.192 0-1.84.676-1.9 1.926l-.001 6.83-.004.163c-.055 1.109-.694 1.6-2.003 1.55l-.024.473.198.004c1.556-.002 2.377-.758 2.377-2.19v-6.82l.013-.172c.089-.886.525-1.29 1.344-1.29.867 0 1.283.451 1.296 1.465V18.03l.004.18c.06 1.173.701 1.807 1.88 1.807 1.239 0 1.881-.705 1.881-2.004V5.348h-.544v12.666l-.004.17c-.045.939-.476 1.36-1.333 1.36-.908 0-1.338-.467-1.34-1.513V5.365L7.48 5.19zm9.04 13.067c.07 1.143.695 1.761 1.834 1.761 1.192 0 1.84-.676 1.9-1.926l.001-6.83.004-.163c.055-1.109.694-1.6 2.003-1.55l.024-.473-.199-.004c-1.555.002-2.376.758-2.376 2.19v6.82l-.013.172c-.089.886-.525 1.29-1.344 1.29-.867 0-1.283-.451-1.296-1.465V5.416l-.004-.18c-.06-1.173-.701-1.807-1.88-1.807-1.239 0-1.881.705-1.881 2.004V18.1h.544V5.433l.004-.17c.045-.939.477-1.36 1.333-1.36.908 0 1.338.467 1.34 1.513v12.666l.006.175z"
    />
  </svg>
);

export default Samples;
